import type { QueueWarning } from '@/api/cockpit';
import { visibleWarnings } from './visible-warnings';

export function groupWarnings(
  warnings: readonly string[],
  warningDetails?: readonly QueueWarning[],
): {
  informative: readonly QueueWarning[];
  obstructive: readonly QueueWarning[];
  fallback: readonly string[];
} {
  if (!warningDetails || warningDetails.length === 0) {
    return {
      informative: [],
      obstructive: [],
      fallback: visibleWarnings(warnings),
    };
  }
  return {
    informative: warningDetails.filter((warning) => warning.category === 'informative'),
    obstructive: warningDetails.filter((warning) => warning.category === 'obstructive'),
    fallback: [],
  };
}
